import Player from './Player';
import bakedConfig from 'config';

// IOS flag, needed to hide unusable Quality button that's for some reason
// visible even though it should not be.
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    document.body.classList.add('ios-device');
}

// Runtime config override: container builds mount /config.json with the
// deployment-specific originWhitelist. Falls back to the baked config when
// the file is absent (local dev) or empty.
const loadConfig = function () {
    return fetch('./config.json', { cache: 'no-store' })
        .then((response) => (response.ok ? response.json() : {}))
        .then((runtimeConfig) => ({ ...bakedConfig, ...runtimeConfig }))
        .catch((error) => {
            if (import.meta.env.DEV) {
                console.warn(
                    'Runtime config.json not loaded, using baked config',
                    error
                );
            }
            return bakedConfig;
        });
};

const initSentry = function (config) {
    if (
        !config.sentry.enabled ||
        new URL(window.location.href).searchParams.get('sentry') !== 'true'
    ) {
        return;
    }
    import('@sentry/browser')
        .then((Sentry) => {
            Sentry.init({
                dsn: config.sentry.dsn,
                tracesSampleRate: 1.0,
                // TODO: replayIntegration is not imported — this throws and is swallowed by .catch. Fix when Sentry is re-enabled.
                integrations: [replayIntegration()],
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0,
            });
            window.Sentry = Sentry;
        })
        .catch((error) => {
            if (import.meta.env.DEV) {
                console.error('Sentry import failed:', error);
            }
        });
};

const whenDomReady = function () {
    return new Promise((resolve) => {
        if (
            document.readyState === 'complete' ||
            document.readyState === 'interactive'
        ) {
            setTimeout(resolve, 0);
        } else {
            document.addEventListener('DOMContentLoaded', resolve);
        }
    });
};

Promise.all([loadConfig(), whenDomReady()]).then(([config]) => {
    console.info(
        '[radiant-mediaplayer-iframe] Starting with origin whitelist:',
        config.originWhitelist
    );
    initSentry(config);
    new Player(document.getElementById('player'), config);
});
